"use client";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

import { useQuery } from "@tanstack/react-query";
import { GetQuotes } from "@/components/api/queries";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Badge } from "../ui/badge";
import QuoteListCard from "../card/quote/quotelist";
import { X } from "lucide-react";

type Props = {
  className?: string;
};

const QuoteList: React.FC<Props> = ({ className }): JSX.Element => {

  const Quotes = useQuery({
    queryKey: ["quotes"],
    staleTime: 60 * 1000 * 5, // 5min cache time
    queryFn: () => GetQuotes().then((res) => res.data),
  });

  return (
    <Sheet>
      <SheetTrigger>
        <Badge
          variant="outline"
          className="animate-pulse flex bg-harvey-red hover:bg-red-900">
          {Quotes.data?.results.length}
        </Badge>
      </SheetTrigger>
      {/* The values can be sm, default, lg, xl, full or content. */}
      <SheetContent className="border-0 shadow-xl shadow-slate-600 bg-harvey-black text-gray-300"
      position={"right"}
      size="content">
        <SheetHeader className="-mt-2">
          <SheetTitle>Active Quotations</SheetTitle>
          <SheetDescription>
            Please action the quotations below.
          </SheetDescription>
        </SheetHeader>
        <ScrollArea className="h-5/6">
          {!Quotes.isLoading &&
            Quotes.data?.results.map((item, index) => (
                <div className="my-2" key={index}>
                    <QuoteListCard Quote={item} />
                </div>
            ))}
        </ScrollArea>
        <SheetFooter className="ml-6">
          <SheetClose asChild>
            <div className="flex space-x-2 py-1">
              <Button variant="standard" aria-label="show notifications" size="sm" type="button">
                <X />
                <span className="p-2">Close</span>

              </Button>
            </div>
          </SheetClose>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};

export default QuoteList;
